// See VisuallyHidden.spec.md for VH-FR-001

import { makeStyles } from '@material-ui/styles'
import type { ReactNode } from 'react'

// VH-FR-001: Styles that hide content on screen but keep it for screen readers. Exported for
// elements that can't be wrapped in a span.
export const VISUALLY_HIDDEN = {
  position: 'absolute',
  width: 1,
  height: 1,
  margin: -1,
  padding: 0,
  border: 0,
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  whiteSpace: 'nowrap',
} as const

const useStyles = makeStyles({ root: VISUALLY_HIDDEN })

// VH-FR-001: Text read by screen readers, not shown
export default function VisuallyHidden({ children }: { children: ReactNode }) {
  const classes = useStyles()
  return <span className={classes.root}>{children}</span>
}
